"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRequest = void 0;
/**
 * Converts a window object to an isomorphic Bernie request
 *
 * @param {AppData} appData The data output of the plugins
 * @param {RouteResult} route The matched route object
 * @param {{ [key: string]: any }} [query={}] An object of key-value pairs
 * @returns {Request} An isomorphic Bernie Request object
 */
var convertRequest = function (appData, route, query) {
    if (query === void 0) { query = {}; }
    return ({
        body: undefined,
        context: appData.context,
        experimentContext: appData.experiment,
        globalComponentsContext: appData.globalComponentsContext,
        headers: {},
        params: route.params || {},
        path: route.location.path,
        url: route.location.path,
        query: query,
        trace: undefined,
    });
};
exports.convertRequest = convertRequest;
//# sourceMappingURL=convert-request.js.map